/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export type TestDataFormat = {
  name: string;
  age: number;
  cypherCommand: string;
};

export const NO_DATA: TestDataFormat[] = [];

export const TABLE_DEMO_DATA: TestDataFormat[] = [
  {
    age: 51,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Alicia Sanford',
  },
  {
    age: 12,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Dallas Kuhn',
  },
  {
    age: 39,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Susan Daugherty MD',
  },
  {
    age: 32,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'PersonWithReallyLongNameToTestLongCells',
  },
  {
    age: 37,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Karen Huel',
  },
  {
    age: 83,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Dustin Hudson PhD',
  },
  {
    age: 60,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Ken Kessler',
  },
  {
    age: 10,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Jonathon Graham',
  },
  {
    age: 68,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Joanne Schinner',
  },
  {
    age: 86,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Tony Runolfsson',
  },
  {
    age: 21,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Courtney McClure',
  },
  {
    age: 98,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Casey Rippin',
  },
  {
    age: 49,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Ms. Renee Sawayn',
  },
  {
    age: 88,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Glenn Grady V',
  },
  {
    age: 13,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Virginia Marvin Jr.',
  },
  {
    age: 37,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Blanca Rutherford',
  },
  {
    age: 22,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Amy Kuphal',
  },
  {
    age: 11,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Wesley Kessler',
  },
  {
    age: 91,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Benjamin Buckridge',
  },
  {
    age: 60,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: "Doreen O'Reilly",
  },
  {
    age: 14,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Beth Kihn',
  },
  {
    age: 49,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Tara Heathcote',
  },
  {
    age: 20,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Geraldine Walsh',
  },
  {
    age: 11,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Mr. Jennie Will',
  },
  {
    age: 68,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Theodore Metz',
  },
  {
    age: 63,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Josefina Nikolaus',
  },
  {
    age: 52,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Allan Schimmel',
  },
  {
    age: 59,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Donald Weissnat',
  },
  {
    age: 18,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Ms. Travis Lemke',
  },
  {
    age: 43,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Eddie Nolan',
  },
  {
    age: 52,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Shawna Kassulke',
  },
  {
    age: 51,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Simon Brekke',
  },
  {
    age: 77,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Cynthia Rodriguez',
  },
  {
    age: 33,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Celia Casper',
  },
  {
    age: 48,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Virginia Harber',
  },
  {
    age: 13,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Marcos Johns',
  },
  {
    age: 34,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Felix Hauck',
  },
  {
    age: 17,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Ismael Moore',
  },
  {
    age: 62,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Jerry Conn',
  },
  {
    age: 37,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Cody Lowe',
  },
  {
    age: 97,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Angela Runte III',
  },
  {
    age: 49,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Todd Hammes',
  },
  {
    age: 31,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Marguerite Grant',
  },
  {
    age: 55,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Melinda Davis',
  },
  {
    age: 96,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Mamie Mante DVM',
  },
  {
    age: 89,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Angelo Johns',
  },
  {
    age: 100,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Kelli Wilderman',
  },
  {
    age: 69,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Catherine McClure',
  },
  {
    age: 10,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Ms. Justin Zboncak',
  },
  {
    age: 54,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Alonzo Leuschke',
  },
  {
    age: 25,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Fredrick Hagenes',
  },
  {
    age: 30,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Gertrude Konopelski',
  },
  {
    age: 13,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Shawn Mosciski',
  },
  {
    age: 57,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Mack Gibson',
  },
  {
    age: 98,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Mrs. Joann Ward',
  },
  {
    age: 37,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Sheldon Jakubowski',
  },
  {
    age: 13,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Lorena Runte',
  },
  {
    age: 35,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Al Gerhold',
  },
  {
    age: 37,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Lori MacGyver',
  },
  {
    age: 88,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Dominic Kris',
  },
  {
    age: 9,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Lynn Kuvalis',
  },
  {
    age: 92,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Virginia Walter',
  },
  {
    age: 17,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Antonia Nolan',
  },
  {
    age: 43,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Cheryl Quitzon',
  },
  {
    age: 72,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Ismael Harris',
  },
  {
    age: 92,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Mr. Jim Cole',
  },
  {
    age: 38,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Melvin Baumbach',
  },
  {
    age: 72,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Marcus King',
  },
  {
    age: 64,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Miss Courtney Nienow',
  },
  {
    age: 25,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Lorenzo Marks',
  },
  {
    age: 20,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Claire Torp',
  },
  {
    age: 86,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Robyn Mitchell',
  },
  {
    age: 42,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Austin Ankunding',
  },
  {
    age: 98,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Peggy Sauer',
  },
  {
    age: 15,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Mike Nikolaus',
  },
  {
    age: 45,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Matthew Russel',
  },
  {
    age: 56,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Lewis Ruecker DDS',
  },
  {
    age: 34,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Dave Abbott',
  },
  {
    age: 79,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Timothy Blanda',
  },
  {
    age: 52,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Emily Ullrich',
  },
  {
    age: 46,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Ebony Ward',
  },
  {
    age: 49,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Jacquelyn Goodwin',
  },
  {
    age: 96,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Moses Ryan',
  },
  {
    age: 34,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Raymond Little',
  },
  {
    age: 53,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Shawn Haley',
  },
  {
    age: 83,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Celia Ritchie',
  },
  {
    age: 91,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: "Wendy O'Connell V",
  },
  {
    age: 33,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Marcos Runolfsson',
  },
  {
    age: 91,
    cypherCommand: 'MATCH (n) RETURN n LIMIT 5',
    name: 'Gladys Pagac',
  },
  {
    age: 87,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Marta Stokes',
  },
  {
    age: 99,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: "Kathryn O'Connell",
  },
  {
    age: 36,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Edwin Bailey',
  },
  {
    age: 82,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Delia Gutkowski',
  },
  {
    age: 55,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Stella Aufderhar',
  },
  {
    age: 31,
    cypherCommand: 'CALL dbms.showCurrentUser()',
    name: 'Lucy Botsford',
  },
  {
    age: 36,
    cypherCommand: 'MATCH (n:Person) WHERE n.born=1964 RETURN n.name AS name',
    name: 'Faye Sanford',
  },
];

// To be used for non-paginated Table instances
export const PRUNED_TABLE_DEMO_DATA: TestDataFormat[] = TABLE_DEMO_DATA.slice(
  0,
  10,
);
